import {http} from '../utils'

const getReportRoles = () => {
  const url = `/api/v1/roles`
  return http.post(url)
}

const getReportList = params => {
  const url = `/api/v1/report/page`
  return http.post(url, params)
}

const deleteReport = id => {
  const url = `/api/v1/report/del?id=${id}`
  return http.get(url)
}

const setReportStatus = (id, status, type) => {
  const url = `/api/v1/report/status?id=${id}&status=${status}&type=${type}`
  return http.get(url)
}

const getReportConditions = () => {
  const url = `/api/v1/report/condition/types`
  return http.get(url)
}

const analysisReportSql = params => {
  const url = `/api/v1/report/analysis/sql`
  return http.post(url, params)
}

const saveReport = params => {
  const url = `/api/v1/report/save`
  return http.post(url, params)
}

const getReportDetail = id => {
  const url = `/api/v1/report/view?id=${id}`
  return http.get(url)
}

const getReportMenu = () => {
  const url = `/api/v1/report/all`
  return http.get(url)
}

const getReportPage = params => {
  const url = `/api/v1/report/detail/page`
  return http.post(url, params)
}

const getInSearchList = params => {
  const url = `/api/v1/report/detail/page/inSearch`
  return http.post(url, params)
}

const getExportPageList = params => {
  const url = `/api/v1/report/detail/export/page`
  return http.post(url, params)
}

const generateReport = params => {
  const url = `/api/v1/report/detail/export/generate`
  return http.post(url, params)
}

const deleteGenerateReport = id => {
  const url = `/api/v1/report/detail/export/del?id=${id}`
  return http.get(url)
}

const deleteReportSearchData = id => {
  const url = `/api/v1/report/search/del?id=${id}`
  return http.get(url)
}

const updateUseReportSearchData = id => {
  const url = `/api/v1/report/search/update?id=${id}`
  return http.get(url)
}


const cancelGenerateReport = id => {
  const url = `/api/v1/report/detail/export/cancel?id=${id}`
  return http.get(url)
}

const getReportConfig = reportId => {
  const url = `/api/v1/report/user/config?reportId=${reportId}`
  return http.get(url)
}

const saveReportConfig = params => {
  const url = `/api/v1/report/user/config/save`
  return http.post(url, params)
}

const saveReportSearchData = params => {
  const url = `/api/v1/report/search/save`
  return http.post(url, params)
}

const getReportSearchData = params => {
  const url = `/api/v1/report/search/page`
  return http.post(url, params)
}

const saveReportSort = (id, sort) => {
  const url = `/api/v1/report/report/sort?id=${id}&sort=${sort}`
  return http.get(url)
}

export default {
  getReportRoles,
  getReportList,
  deleteReport,
  setReportStatus,
  getReportConditions,
  analysisReportSql,
  saveReport,
  getReportDetail,
  getReportMenu,
  getReportPage,
  getInSearchList,
  getExportPageList,
  generateReport,
  deleteGenerateReport,
  cancelGenerateReport,
  getReportConfig,
  saveReportConfig,
  saveReportSearchData,
  getReportSearchData,
  deleteReportSearchData,
  updateUseReportSearchData,
  saveReportSort
}
